import React from 'react';
import { Link, useLocation } from 'react-router-dom';

function Sidebar({ onLogout }) {
    const location = useLocation();

    // Wir holen den Namen für die Anzeige in der Sidebar
    const userName = localStorage.getItem('userName') || 'Kollege';

    const menuItems = [
        { name: 'Dashboard', path: '/', icon: '🏠' },
        { name: 'Bayes-Inferenz', path: '/bayes', icon: '🧠' },
        { name: 'GefäßKalkulator', path: '/gefaess', icon: '🩺' },
        { name: 'Patientenverwaltung', path: '/patients', icon: '👥' },
    ];

    return (
        <div className="w-64 bg-slate-900 text-white h-screen flex flex-col p-4 shadow-xl">
            {/* Logo Bereich */}
            <div className="mb-10 px-2 pt-4">
                <h1 className="text-2xl font-bold text-blue-400 tracking-tight">Klinik Portal</h1>
                <div className="flex items-center gap-2 mt-2">
                    <div className="w-2 h-2 bg-emerald-500 rounded-full animate-pulse"></div>
                    <p className="text-xs text-slate-400 uppercase tracking-widest font-semibold">System Online</p>
                </div>
            </div>

            {/* Navigation */}
            <nav className="flex-1 space-y-2">
                {menuItems.map((item) => {
                    const isActive = location.pathname === item.path;
                    return (
                        <Link
                            key={item.path}
                            to={item.path}
                            className={`flex items-center gap-3 p-3 rounded-xl transition-all duration-200 group ${
                                isActive
                                    ? 'bg-blue-600 text-white shadow-lg shadow-blue-900/20'
                                    : 'text-slate-400 hover:bg-slate-800 hover:text-white'
                            }`}
                        >
              <span className={`text-xl transition-transform group-hover:scale-110 ${isActive ? '' : 'grayscale'}`}>
                {item.icon}
              </span>
                            <span className="font-medium">{item.name}</span>
                        </Link>
                    );
                })}
            </nav>

            {/* User & Logout Bereich ganz unten */}
            <div className="mt-auto border-t border-slate-800 pt-6 pb-2 px-2">
                <div className="flex flex-col mb-4">
                    <span className="text-[10px] text-slate-500 uppercase font-bold tracking-wider">Aktueller Benutzer</span>
                    <span className="text-slate-200 font-medium truncate">{userName}</span>
                </div>

                <button
                    onClick={onLogout}
                    className="w-full flex items-center justify-center gap-2 bg-red-500/10 hover:bg-red-500 text-red-500 hover:text-white py-3 rounded-xl border border-red-500/20 transition-all duration-300 group"
                >
                    <span className="text-lg group-hover:rotate-12 transition-transform">🚪</span>
                    <span className="font-bold text-sm">Abmelden</span>
                </button>
            </div>
        </div>
    );
}

export default Sidebar;